import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/dev/design")({
  head: () => ({
    meta: [{ title: "设计系统 · imiker CRM" }],
  })
});
